















import { Component, Prop, Vue } from "vue-property-decorator";
import { DayDone, DayUnable } from "./guidelineApi";
import CzPlanRow from "../cz/CzPlanRow.vue";

// One guideline in a list: in "Today" and in the guideline detail it can be marked (D37); inside a program plan it only informs (D38).
@Component({ components: { CzPlanRow } })
export default class GuidelineRow extends Vue {
  @Prop({ type: Object, required: true }) row!: any;
  @Prop({ type: String, default: "" }) origin!: string;
  @Prop({ type: String, required: true }) to!: string;
  @Prop({ type: Boolean, default: false }) busy!: boolean;
  @Prop({ type: Boolean, default: false }) plan!: boolean;

  get done(): boolean {
    return this.row.todayStatus === DayDone;
  }

  get state(): string {
    if (this.plan) return "";
    if (this.row.todayStatus === DayUnable) return this.$t("Today you could not").toString();
    if (this.done) return "";
    if (this.row.nextSessionTitle) return this.$t("Your turn: {0}").toString().replace("{0}", this.row.nextSessionTitle);
    return "";
  }

  get week(): string {
    return this.$t("{0} of {1} days this week").toString().replace("{0}", this.row.weekDone).replace("{1}", this.row.weekTarget);
  }

  get sub(): string {
    return [this.state, this.week].filter((bit) => bit).join(" · ");
  }

  get checkLabel(): string {
    return (this.done ? this.$t("Unmark {0}").toString() : this.$t("Mark {0} as done today").toString()).toString().replace("{0}", this.row.name);
  }
}
